import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      text: '"AIVION transformed our data infrastructure, enabling us to make decisions with confidence. Their expertise in financial services is unmatched."',
      author: 'Sarah Mitchell',
      role: 'CTO, Financial Corp'
    },
    {
      text: '"The aivionGrade platform has revolutionised how we assess students. Faster turnaround, consistent marking, and actionable insights."',
      author: 'Dr James Chen',
      role: 'Dean of Academics'
    },
    {
      text: '"Their GenAI solutions went from concept to production in weeks, not months. Truly outcome-driven partnership."',
      author: 'Priya Sharma',
      role: 'Head of Innovation'
    }
  ];

  return (
    <section id="testimonials" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>What Our Clients Say</h2>
          <p>Trusted by organisations across industries for delivering measurable AI outcomes.</p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <h4>{testimonial.author}</h4>
                <span>{testimonial.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
